import Link from 'next/link'

import { Shimmer } from '@wartek-id/shimmer'
import { Badge } from '@wartek-id/badge'

import { useSETrackerEvent } from 'app/PelatihanMandiriPage/hooks/useSETrackEvent'

import type {
  TAPIGetTopicRecommendation,
  TTopicRecommendationContextualize,
} from 'types/microlearning'

interface TopicRecommendationProps extends Partial<TAPIGetTopicRecommendation> {
  isLoading?: boolean
}

const TopicRecommendation = ({
  title,
  subtitle,
  contextualizePages,
  isLoading,
}: TopicRecommendationProps) => {
  const { SETrackRecommendationCollection } = useSETrackerEvent()

  const items = contextualizePages || []

  const generateUrl = (contextualizedId: number) => {
    return `/pelatihan-mandiri/contextualized-learning/${contextualizedId}`
  }

  const handleTracker = (item: TTopicRecommendationContextualize) => {
    SETrackRecommendationCollection({
      action_type: 'click_theme_collection',
      action_value: 'click_theme',
      contextualized_page_id: item.id,
      contextualized_page_name: item.pageTitle,
    })
  }

  if (isLoading) {
    return (
      <div>
        <Shimmer className="rounded-md mb-2" />
        <div className="py-4 px-4 bg-white rounded-md border border-gray-20 relative h-28">
          <div className="flex justify-between">
            <div>
              <Shimmer width={120} className="rounded-md mb-2" />
              <Shimmer className="rounded-md" />
            </div>
            <Shimmer className="rounded-md" height={64} width={64} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="mb-2">
        <div className="flex items-start">
          <div className="flex items-center">
            <img
              src="https://storage.googleapis.com/microlearning-public-production/web-assets/img-book-literature.png"
              height={24}
              width={24}
              alt="Topik Bertema"
            />
          </div>
          <div className="flex-1 ml-2">
            <div className="font-semibold text-lg">{title}</div>
          </div>
        </div>
        <div>
          <div className="leading-relaxed text-gray-70 text-sm">{subtitle}</div>
        </div>
      </div>
      {items.map((item, idx) => (
        <div key={`recommendation-${idx}`} onClick={() => handleTracker(item)}>
          <Link href={generateUrl(item.id)} passHref>
            <div className="py-4 px-4 bg-white rounded-md border border-gray-20 relative mb-4">
              {item.label && (
                <Badge
                  className="absolute -top-3 right-0 z-10"
                  variant="informational"
                >
                  {item.label}
                </Badge>
              )}
              <div className="flex justify-between">
                <div>
                  <div className="text-md font-semibold flex-1">
                    {item?.pageTitle}
                  </div>
                  {item.pageExcerpt && (
                    <div className="leading-relaxed text-gray-70 line-clamp-2 text-sm">
                      {item.pageExcerpt}
                    </div>
                  )}
                </div>
                <div className="flex-none ml-2">
                  <img
                    src={item.pageThumbnailUrl}
                    className="rounded-md h-[64px] w-[64px] object-cover"
                    alt={item?.pageTitle}
                  />
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  )
}

export default TopicRecommendation
